import { NextPage } from 'next';
import Head from 'next/head';

import { AuthorizedOnly } from 'modules/common/auth';
import { Page, PageLoading } from 'modules/common/layout';
import { Page as Content } from 'modules/account';

/**
 * Главная страница личного кабинета пользователя.
 */
const Account: NextPage = () => (
  <Page>
    <AuthorizedOnly fallback={<PageLoading />}>
      <Head>
        <title>Аполлон-займ</title>
      </Head>
      <Content />
    </AuthorizedOnly>
  </Page>
);

export default Account;
